// extracted by mini-css-extract-plugin
export default {"cautionBox":"N_-z"};